import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CoreModule } from '@app/core/core.module';
import { ResponsiveState } from '@app/core/states/responsive.state';
import { UiModule } from '@app/ui';
import { DateTimePickerComponent } from '@app/ui/components/date-time-picker/date-time-picker.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { NotificationCongratsDialogComponent } from './components/notification-congrats-dialog/notification-congrats-dialog.component';
import { NotificationFormAlertComponent } from './components/notification-form-alert/notification-form-alert.component';
import { NotificationFormHeaderComponent } from './components/notification-form/notification-form-header/notification-form-header.component';
import { NotificationFormMessageInputComponent } from './components/notification-form/notification-form-message-input/notification-form-message-input.component';
import { NotificationFormPlatformSelectorComponent } from './components/notification-form/notification-form-platform-selector/notification-form-platform-selector.component';
import { NotificationFormComponent } from './components/notification-form/notification-form.component';
import { NotificationTargetedSubscribersComponent } from './components/notification-form/notification-targeted-subscribers/notification-targeted-subscribers.component';
import { NotificationShellComponent } from './components/notification-shell/notification-shell.component';
import { NotificationSidebarComponent } from './components/notification-sidebar/notification-sidebar.component';
import { NotificationTableComponent } from './components/notification-table/notification-table.component';
import { NotificationsState } from './states/notifications.state';
import { NotificationFormDeeplinksComponent } from './components/notification-form/notification-form-deeplinks/notification-form-deeplinks.component';
import { NotificationFormTitleInputComponent } from './components/notification-form/notification-form-title-input/notification-form-title-input.component';

@NgModule({
  declarations: [
    NotificationTableComponent,
    NotificationShellComponent,
    NotificationFormComponent,
    NotificationSidebarComponent,
    NotificationFormAlertComponent,
    NotificationTargetedSubscribersComponent,
    NotificationCongratsDialogComponent,
    NotificationFormHeaderComponent,
    NotificationFormMessageInputComponent,
    NotificationFormPlatformSelectorComponent,
    NotificationFormDeeplinksComponent,
    NotificationFormTitleInputComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    UiModule,
    MatProgressSpinnerModule,
    FontAwesomeModule,
    TranslateModule,
    DateTimePickerComponent,
    NgxsModule.forFeature([NotificationsState, ResponsiveState]),
    ReactiveFormsModule,
  ],
  exports: [NotificationTableComponent, NotificationSidebarComponent],
})
export class NotificationsModule {}
